import { createRoute, useSearch } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { appRoute } from "./route";
import { PantryView } from "@/features/pantry/components/pantry-view";
import { PageContainer } from "@/components/ui/page-container";

interface PantrySearch {
  /** Panel "recetas con <ingrediente>" (`?ingredient=<name>`). */
  ingredient?: string;
}

function PantryPage() {
  const search = useSearch({ from: "/u/$u/pantry" });
  const navigate = useNavigate();

  // El panel de descubrimiento "recetas con <ingrediente>" es deep-linkable
  // (`?ingredient=`): la URL es la fuente de verdad para abrir/cerrar el panel.
  const setIngredient = (ingredient: string): void => {
    const trimmed = ingredient.trim();
    if (trimmed === (search().ingredient ?? "")) {
      return;
    }
    void navigate({
      to: "/pantry",
      search: trimmed ? { ingredient: trimmed } : {},
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="3xl">
      <PantryView selectedIngredient={search().ingredient} onIngredientChange={setIngredient} />
    </PageContainer>
  );
}

export const pantryRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/pantry",
  validateSearch: (search: Record<string, unknown>): PantrySearch => ({
    ingredient:
      typeof search.ingredient === "string" && search.ingredient.trim() !== ""
        ? search.ingredient
        : undefined,
  }),
  component: PantryPage,
});
